export default "__VITE_ASSET__n62LBOE6__"